<div class="page-container">
    <div>
        <!-- <div class="manage-btn-container">
            <div></div>
            <div></div>
            <div>
                <button *ngIf="user.isAdmin" mat-raised-button class="manage-report-btn"
                    (click)="openViewReportsOfDialog()">
                    {{plaintext.viewReportsOf.title[user.language]}}
                </button>
                <button *ngIf="user.isPSC && viewingDashboardAsEmployee" mat-raised-button class="manage-report-btn"
                    (click)="openViewReportsOfDialog()">
                    {{plaintext.viewReportsOf.title[user.language]}}
                </button>
                <button *ngIf="(!viewingDashboardAsPSC && !viewingDashboardAsEmployee) && user.isAdmin && !isMobile"
                    mat-raised-button class="manage-report-btn" (click)="goToManageReports()">
                    {{plaintext.manageReports.title[user.language]}}
                </button>
            </div>
        </div> -->
        <div class="header5" *ngIf="viewingDashboardAsPSC">Viewing the reports of a PSC admin at the dealership: <span
                style="font-weight: bold;">{{dealerName}}</span> </div>
        <div class="header5" *ngIf="viewingDashboardAsEmployee">
            <div>
                {{plaintext.viewReportsOf.employee[user.language]}}
                <span style="font-weight: bold;">{{userName}}</span>
                <span *ngIf="!user.isPSC"> at {{dealerName}}</span>
            </div>
        </div>
        <div style="display: flex;">
            <!-- <div class="profile-card-container"
                *ngIf="user.isPSC && !viewingDashboardAsPSC && !viewingDashboardAsEmployee && !isLoading"> -->
                <!-- <div class="initials"><span class="initials-text"> {{userInitials}} </span></div> -->
                <!-- <div class="user-info">
                    <div class="user-name header2">
                        {{plaintext.reports.hi[user.language]}}, {{user.name}}</div>
                </div> -->
                <!-- <div class="option-buttons">
                    <div class="admin-card-button" routerLink="/reports/manage">
                        <img class="admin-card-button-image" src="../../../assets/buttons/Manage-Reports.png" />
                        <span class="admin-card-button-text">{{plaintext.manageReports.title[user.language]}}</span>
                    </div>
                    <div class="admin-card-button" (click)="openViewReportsOfDialog()">
                        <img class="admin-card-button-image" src="../../../assets/buttons/View-Reports-of.png" />
                        <span class="admin-card-button-text">{{plaintext.viewReportsOf.title[user.language]}}</span>
                    </div>
                </div> -->
            <!-- </div> -->
            <mat-spinner class="loading-spinner" *ngIf="isLoading"></mat-spinner>
            <div *ngIf="!isLoading" class="reports-container">
                <mat-card class="report-card" *ngFor="let report of userReports" (click)="openReport(report)">
                    <i-feather class="info-icon" name="info" [matTooltip]="report.tooltip"
                        [matTooltipClass]="{ 'tooltipClass' : true }"></i-feather>
                    <div class="report-top">
                        <img class="report-icon" src="../../../assets/buttons/Maxis-Suppliers.png">
                        <div class="report-name header3">
                            {{report.name}}
                        </div>
                    </div>

                    <!-- <div>{{report.description}}</div> -->
                    <div class="report-description">
                        {{report.description}}
                    </div>
                    <!-- <div class="icon-container">
                <img *ngIf="report.imageUrl" class="report-icon" [src]="report.imageUrl" />
            </div>
            <div class="description-container">
                <div class="report-name">{{report.name}}</div>
                <div class="report-description">
                    {{report.description}}
                </div>
            </div> -->
                </mat-card>
            </div>
        </div>
        <div *ngIf="!isLoading && userReports.length == 0" class="not-found-container">
            <img class="not-found-icon" src="../../assets/icons/locked-report.svg" />
            <p class="not-found-text header-text subtitle2">
                <span *ngIf="viewingDashboardAsPSC">{{dealerName}}
                    {{plaintext.viewReportsOf.employeeNoAccess[user.language]}}</span>
                <span *ngIf="viewingDashboardAsEmployee">{{userName}}
                    {{plaintext.viewReportsOf.employeeNoAccess[user.language]}}</span>
                <span *ngIf="!viewingDashboardAsPSC && !viewingDashboardAsEmployee" class="subtitle5">
                    {{plaintext.reports.noAccess[user.language]}}
                </span>
            </p>
            <div class="psc-container"
                *ngIf="(user.businessFunction == 'DEALER' && !user.isPSC && !viewingDashboardAsEmployee && !viewingDashboardAsPSC) || (viewingDashboardAsEmployee && !user.isPSC)">
                <p class="subtitle5">{{plaintext.reports.contactPSC[user.language]}}</p>
                <app-data-table [displayedColumns]="pscAdminColumns" [tableData]="pscAdmins" [initSortColumn]="0"
                    [initSortDirection]="'desc'" [selectable]="false"></app-data-table>
            </div>
            <p *ngIf="user.isPSC && !viewingDashboardAsEmployee && !viewingDashboardAsPSC"
                class="not-found-text header-text subtitle2">
                {{plaintext.reports.contactDM[user.language]}}
            </p>
        </div>
    </div>
    <p class="contact-psc-text" (click)="openAdminsDialog()" *ngIf="!isLoading && userReports && userReports.length > 0 && user.businessFunction == 'DEALER' && !user.isPSC">
        {{plaintext.reports.pscHelpText[user.language]}}</p>
</div>